const onFetchFailure = (data, setErrors, setErrorMessage) => {
  const { errors, message, type } = data.error || {}
  if (type === 'Validation Error') {
    const parsedErrors = Object.values(errors).join(', ')
    setErrors(errors)
    setErrorMessage(`There was a problem: ${parsedErrors}.`)
    return
  }

  setErrorMessage({
    errorMessage: `There was a problem: ${message || 'Please try again later.'}`
  })
}

export default onFetchFailure
